export const iconFontAwesomeHumanitarianShip = (
	<i className="fa-solid fa-ship"></i>
);
